// @flow

/**
 * The type of the Redux action which signals that a suspend was detected.
 *
 * {
 *     type: SUSPEND_DETECTED
 * }
 * @public
 */
export const SUSPEND_DETECTED = 'SUSPEND_DETECTED';

/**
 * The type of the Redux action which signals that a transport needs to be stored.
 *
 * {
 *     type: SET_TRANSPORT
 * }
 * @public
 */
export const SET_TRANSPORT = 'SET_TRANSPORT';
